import { Component, input } from '@angular/core';
import { UwIcon } from '../../ui/icon/uw-icon';
import { UwProgressRing } from '../../ui/progress-ring/uw-progress-ring';
import { UwSkeleton } from '../../ui/skeleton/uw-skeleton';
import type { RiskAssessment } from '../../../core/models/risk.model';

@Component({
  selector: 'uw-risk-score',
  standalone: true,
  imports: [UwIcon, UwProgressRing, UwSkeleton],
  template: `
    @if (loading()) {
      <div class="flex items-center gap-4 p-4">
        <uw-skeleton width="88px" height="88px" rounded="full" />
        <div class="flex-1 space-y-2">
          <uw-skeleton width="55%" height="16px" />
          <uw-skeleton width="40%" height="12px" />
          <uw-skeleton width="70%" height="12px" />
        </div>
      </div>
    } @else if (assessment(); as a) {
      <div class="flex items-center gap-4 p-4">
        <uw-progress-ring [value]="a.compositeScore" [size]="88" [stroke]="8" [tone]="a.scoreTone" [label]="a.riskLabel" />
        <div class="min-w-0">
          <div class="flex items-center gap-1.5">
            <h3 class="text-[14px] font-semibold text-primary">Risk Assessment Engine</h3>
            <uw-icon name="check-circle" [size]="13" class="text-success" />
          </div>
          <p class="mt-0.5 text-[11.5px] text-secondary">
            {{ a.riskLabel }} risk · composite score <span class="typo-mono font-bold">{{ a.compositeScore }}</span>/100
          </p>
          <p class="mt-0.5 flex items-center gap-1 text-[10.5px] text-text-muted">
            <uw-icon name="clock" [size]="11" />
            Updated {{ a.updated }} · model v4.2
          </p>
        </div>
      </div>
    }
  `,
})
export class UwRiskScore {
  readonly assessment = input<RiskAssessment | null>(null);
  readonly loading = input(false);
}
